/* global axios */
import ApiClient from './ApiClient';

class ConversationFollowUpsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getEnrollment(conversationId) {
    return axios.get(`${this.url}/${conversationId}/follow_up_enrollment`);
  }

  enroll(conversationId) {
    return axios.post(`${this.url}/${conversationId}/follow_up_enrollment`);
  }

  pause(conversationId, enrollmentId) {
    return axios.post(
      `${this.url}/${conversationId}/follow_up_enrollment/pause`,
      { enrollment_id: enrollmentId }
    );
  }

  resume(conversationId, enrollmentId) {
    return axios.post(
      `${this.url}/${conversationId}/follow_up_enrollment/resume`,
      { enrollment_id: enrollmentId }
    );
  }

  remove(conversationId, enrollmentId) {
    return axios.post(
      `${this.url}/${conversationId}/follow_up_enrollment/remove`,
      { enrollment_id: enrollmentId }
    );
  }
}

export default new ConversationFollowUpsAPI();
